import { relations } from 'drizzle-orm'
import {
  entities,
  bankAccounts,
  counterparts,
  paymentTerms,
  paymentTermsByEntityRelationName,
  entityUsers,
  vat,
} from './entities.schema'
import { paymentReminders, reminderEmailTemplates } from './payment-reminders.schema'
import { receivables, billableHoursCategories } from '../receivables/receivables.schema'
import { catalogItems } from '../catalog/catalog.schema'

export const entitiesRelations = relations(entities, ({ many }) => ({
  bankAccounts: many(bankAccounts),
  counterparts: many(counterparts),
  paymentTerms: many(paymentTerms, { relationName: paymentTermsByEntityRelationName }),
  paymentReminders: many(paymentReminders),
  reminderEmailTemplates: many(reminderEmailTemplates),
  receivables: many(receivables),
  users: many(entityUsers),
  vat: many(vat),
}))

export const counterpartsRelations = relations(counterparts, ({ one, many }) => ({
  entity: one(entities, {
    fields: [counterparts.entityId],
    references: [entities.id],
  }),
  receivables: many(receivables),
}))

// Cross-schema relations to avoid circular dependencies
export const billableHoursCategoriesRelations = relations(billableHoursCategories, ({ one }) => ({
  entity: one(entities, {
    fields: [billableHoursCategories.entityId],
    references: [entities.id],
  }),
  catalogItem: one(catalogItems, {
    fields: [billableHoursCategories.catalogItemId],
    references: [catalogItems.id],
  }),
}))
